import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import EstimateForm from '../../components/Estimate/EstimateForm';
import { EstimateViewModel } from '../../models/estimate/EstimateViewModel';

export default function EstimatesEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const [estimate, setEstimate] = useState(
    null as unknown as EstimateViewModel
  );

  async function getEstimate() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/estimates/${id}`
      );
      setEstimate(new EstimateViewModel(response.data));
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getEstimate();
  }, [organization, id]);

  return estimate ? (
    <EstimateForm
      isLoading={isLoading}
      estimate={estimate}
      refreshEstimate={() => getEstimate()}
      onSubmit={() => {}}
    />
  ) : (
    <div>Carregando...</div>
  );
}
